import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcMinusSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.00015 12.0004C5.00015 11.4481 5.44787 11.0004 6.00015 11.0004L18.0006 11.0004C18.5529 11.0004 19.0006 11.4481 19.0006 12.0004C19.0006 12.5527 18.5529 13.0004 18.0006 13.0004L6.00015 13.0004C5.44787 13.0004 5.00015 12.5527 5.00015 12.0004Z",
		fill: "inherit"
	})
});
export default SvgIcMinusSmallOl;
